(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-product-faq"] && !Shopify.designMode) return;
  try {
    
  /**
   * @fileoverview Accordion Web Component
   * @description Provides expandable/collapsible accordion functionality.
   *   Supports single or multiple active items.
   * 
   * @example
   * <accordion-wrapper>
   *   <div class="td-accordion__item" data-item="0">
   *     <div class="td-accordion__toggle">Title</div>
   *     <div class="td-accordion__content">Content</div>
   *   </div>
   * </accordion-wrapper>
   */

  if (!customElements.get("accordion-wrapper")) {
    class Accordion extends HTMLElement {
      constructor() {
        super();
        this.options = this.dataset.options;
        this.onlyOneActive = false;
      }

      connectedCallback() {
        this.items = this.querySelectorAll(".td-accordion__item");
        if (this.items.length) {
          this.initializeAriaAttributes();
          this.bindEvents();
        }
      }

      initializeAriaAttributes() {
        this.items.forEach(function (item) {
          const toggle = item.querySelector(".td-accordion__toggle");
          const isInitiallyOpen = item.dataset.open || item.classList.contains("is-active");
          if (toggle) {
            toggle.setAttribute("aria-expanded", isInitiallyOpen ? "true" : "false");
          }
        });
      }

      bindEvents() {
        const el = this;
        this.items.forEach(function (item) {
          const toggle = item.querySelector(".td-accordion__toggle");
          if (toggle) {
            // Handle click events
            toggle.addEventListener("click", function (event) {
              event.preventDefault();
              el.toggle(item.dataset.item);
            });

            // Handle keyboard events (Enter and Space)
            toggle.addEventListener("keydown", function (event) {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                el.toggle(item.dataset.item);
              }
            });

            if (item.dataset.open) {
              el.toggle(item.dataset.item);
            }
          }

          const toggleNext = item.querySelector(".td-accordion__toggle-next");
          if (toggleNext) {
            toggleNext.addEventListener("click", function (event) {
              event.preventDefault(), el.toggle(parseInt(item.dataset.item) + 1);
            });
          }
        });
      }

      toggle(currentItem) {
        const el = this;
        this.items.forEach(function (item) {
          const content = item.querySelector(".td-accordion__content");
          const toggle = item.querySelector(".td-accordion__toggle");
          if (!content) return;
          if (item.dataset.item == currentItem) {
            const isActive = item.classList.contains("is-active");
            if (isActive) {
              content.style.maxHeight = null;
              if (toggle) {
                toggle.setAttribute("aria-expanded", "false");
              }
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
              if (toggle) {
                toggle.setAttribute("aria-expanded", "true");
              }
            }
            item.classList.toggle("is-active");
          } else if (el.onlyOneActive) {
            item.classList.remove("is-active");
            content.style.maxHeight = null;
            if (toggle) {
              toggle.setAttribute("aria-expanded", "false");
            }
          }
        });
      }
    }

    customElements.define("accordion-wrapper", Accordion);
  }

  } catch(e) { console.error(e); }
})();
})();
